import { HttpErrorResponse } from "@angular/common/http";
import { ToastController } from "ionic-angular";
import { OrderError } from "./models";

export interface OrderErrorResponse {
  errors?: Array<OrderError>;
  correlationId?: string;
}

export namespace OrderErrorResponse {
  export function toMessage(
    orderErrorResponse: OrderErrorResponse,
    errorCode: number
  ): string {
    let message = "";
    for (const singleError of orderErrorResponse.errors) {
      message += `${singleError.message}\n`;
    }
    if (
      orderErrorResponse.correlationId &&
      errorCode >= 500 &&
      errorCode < 600
    ) {
      message += `Correlation Id: ${orderErrorResponse.correlationId}\nPlease forward this error message to Support for resolution.`;
    }
    return message;
  }

  export function handleError(
    toastCtrl: ToastController,
    defaultMessage: string,
    callback?: Function
  ) {
    return (err: HttpErrorResponse) => {
      console.log(err.error);
      try {
        const errorResponse = err.error as OrderErrorResponse;
        const errorCode = err.status;
        const toast = toastCtrl.create({
          message: OrderErrorResponse.toMessage(errorResponse, errorCode),
          showCloseButton: true,
          position: "below",
          cssClass: "error",
        });
        toast.present();
      } catch (_parseError) {
        let toast = toastCtrl.create({
          message: defaultMessage,
          duration: 3000,
          position: "below",
          cssClass: "error",
        });
        toast.onDidDismiss(() => {
          // Do nothing
        });
        toast.present();
      }
      if (typeof callback === "function") {
        callback();
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/order-management/errorResponse.ts